import authHeader from "@/services/auth-header";
import axios from "axios";

export default {
  data() {
    return {
      download_busy: false,
    };
  },
  methods: {
    download(url) {
      this.download_busy = true;
      let fullUrl = `${process.env.VUE_APP_ROOT}/documents/get/${url}`;
      console.log(url+' '+fullUrl);
      //@click.prevent="download(`${item.id}/original/${item.name}`)"
      axios
        .get(fullUrl, { responseType: "blob", headers: authHeader() })
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const link = document.createElement("a");
          link.download = url;
          if (response.data.type == "audio/mpeg") {
            link.download = url + ".mp3";
          }
          link.href = URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();
          URL.revokeObjectURL(link.href);
          this.download_busy = false;
        })
        .catch((e) => {
          this.$bvToast.toast(e+"il file richiesto non esiste più", {
            title: "Errore",
            autoHideDelay: 2000,
            appendToast: true,
            variant: "danger",
          });
        });
      this.download_busy = false;
    },
    getSvgImg(pet) {
      var image = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";
      try {
        image = "/iconss/" + pet + ".svg";
      } catch (e) {
        console.log("Manca icona " + pet);
      }
      return image;
    },
    getFlag(lang) {
      if (this.langs.length == 0 || lang == undefined || lang.length == 0) {
        return "";
      }
      return this.langs.find((x) => x.id == lang).flag;
    },
    getMap(arr) {
      var result = new Map(arr.map((arr) => [arr.id, arr.name]));

      return result;
    },
    getIniziali(user) {
      if (user == undefined) {
        return "--";
      }
      if (user.first_name.lenght > 0 && user.last_name.lenght > 0) {
        return `${user.first_name.substr(0, 1)} ${user.last_name.substr(0, 1)}`;
      }
      return "--";
    },
    getExtension(fname) {
      const re = /(?:\.([^.]+))?$/;

      let ext = re.exec(fname)[1];
      return ext;
    },
    showError(e) {
      console.log(e.response);
      this.$bvToast.toast(e.response.data.message, {
        title: "Errore",
        autoHideDelay: 2000,
        appendToast: true,
        variant: "danger",
      });
    },
    isAutoTranslatable(item) {
      let ext = this.getExtension(item.name);
      console.log(item);
      const autoTransatable = [
        "doc",
        "odt",
        "docx",
        "ppt",
        "pptx",
        "xlsx",
        "xls",
        "rtf",
        "odp",
        "ods",
        "pdf",
        "html",
        "xml",
        "json",
        "txt",
      ];
      return autoTransatable.includes(ext.toLowerCase());
    },
  },
  computed: {
    nomeTipo() {
      if (this.item == undefined) {
        return;
      }

      if (this.item.document_type) {
        return `${this.item.name} [${this.item.document_type}]`;
      } else {
        return this.item.name;
      }
    },
  },
};
